import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AuthUser } from 'aws-amplify/auth'

interface AuthState {
  user: AuthUser | null
  isAuthenticated: boolean
  isAdmin: boolean
  setUser: (user: AuthUser | null) => void
  setIsAdmin: (isAdmin: boolean) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      isAdmin: false,
      setUser: (user) => set({ user, isAuthenticated: user !== null }),
      setIsAdmin: (isAdmin) => set({ isAdmin }),
      clearAuth: () => set({ user: null, isAuthenticated: false, isAdmin: false }),
    }),
    {
      name: 'auth-storage',
      // Only persist the minimum needed — never the raw token
      partialize: (state) => ({ isAuthenticated: state.isAuthenticated }),
    },
  ),
)
